import Customers from '@/views/Customer/Customers';
import CustomerUpdate from '@/views/Customer/CustomerUpdate';
import CustomerDetails from '@/views/Customer/CustomerDetails';
import CustomerDetailsMain from '@/views/Customer/CustomerDetailsMain';
import CustomerDetailsLoanHistory from '@/views/Customer/CustomerDetailsLoanHistory';
import CustomerDetailsCreditDatabase from '@/views/Customer/CustomerDetailsCreditDatabase';
import CustomerDetailsSocialInsurance from '@/views/Customer/CustomerDetailsSocialInsurance';
import CustomerDetailsNotesHistory from '@/views/Customer/CustomerDetailsNotesHistory';
import { requiresCustomersAccess, requiresCustomersUpdateAccess } from '@/router/helpers';

export default [
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    beforeEnter: requiresCustomersAccess,
    meta: {
      group: 'customers',
      roles: [
        'ADMINISTRATOR',
        'CHIEF_LOAN_OFFICER',
        'LOAN_OFFICER',
        'COLLECTIONS_OFFICER',
        'VIEWER',
      ],
      title: 'Customers',
    },
  },
  {
    path: '/customers/update/:customerId',
    name: 'CustomerUpdate',
    component: CustomerUpdate,
    beforeEnter: requiresCustomersUpdateAccess,
    meta: {
      group: 'customers',
      roles: ['ADMINISTRATOR', 'CHIEF_LOAN_OFFICER', 'LOAN_OFFICER'],
    },
  },
  {
    path: '/customers/:customerId',
    component: CustomerDetails,
    beforeEnter: requiresCustomersAccess,
    meta: {
      group: 'customers',
      roles: [
        'ADMINISTRATOR',
        'CHIEF_LOAN_OFFICER',
        'LOAN_OFFICER',
        'COLLECTIONS_OFFICER',
        'VIEWER',
      ],
    },
    children: [
      {
        path: '',
        name: 'CustomerDetails',
        component: CustomerDetailsMain,
        meta: {
          title: 'CustomerDetails',
        },
      },
      {
        path: 'loan-history',
        name: 'CustomerDetailsLoanHistory',
        component: CustomerDetailsLoanHistory,
        meta: {
          title: 'CustomerDetails',
        },
      },
      {
        path: 'credit-database',
        name: 'CustomerDetailsCreditDatabase',
        component: CustomerDetailsCreditDatabase,
        meta: {
          title: 'CustomerDetails',
        },
      },
      {
        path: 'social-insurance',
        name: 'CustomerDetailsSocialInsurance',
        component: CustomerDetailsSocialInsurance,
        meta: {
          title: 'CustomerDetails',
        },
      },
      {
        path: 'notes-history',
        name: 'CustomerDetailsNotesHistory',
        component: CustomerDetailsNotesHistory,
        meta: {
          title: 'CustomerDetails',
        },
      },
    ],
  },
];
